/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const Q_my_hp_low = require('./Q_my_hp_low');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');

const Q_status_of_best_target = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  node.MESSED_UP = 0;
  node.NOT_STUNNED = 1;
  node.NOT_ENRAGED = 2;

  node.bash = BattleCalc.getEquippedAbility(actor, 'bash');
  node.taunt = BattleCalc.getEquippedAbility(actor, 'taunt');

  node.branches[node.MESSED_UP] = new Q_my_hp_low(actor, battleState);

  node.branches[node.NOT_STUNNED] = node.bash
    ? new UseAbility({
        actor,
        abilityHandle: 'bash',
        altNode: node.branches[node.MESSED_UP],
      })
    : node.branches[node.MESSED_UP];

  node.branches[node.NOT_ENRAGED] = node.taunt
    ? new UseAbility({
        actor,
        abilityHandle: 'taunt',
        altNode: node.branches[node.MESSED_UP],
      })
    : node.branches[node.MESSED_UP];

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.bash = null;
    node.taunt = null;
    originalDispose.call(node);
  };

  node.query = function () {
    const bestTarget = AICalc.getBestMeleeTarget(actor, battleState);

    if (!bestTarget) {
      return this.branches[this.MESSED_UP].query();
    }

    if (
      this.bash &&
      !BattleCalc.getCondition(bestTarget, 'stunned') &&
      !BattleCalc.getCondition(bestTarget, 'liberated')
    ) {
      return this.branches[this.NOT_STUNNED].query(bestTarget);
    } else if (
      this.taunt &&
      !BattleCalc.getCondition(bestTarget, 'stunned') && // don't taunt a stunned target
      !BattleCalc.getCondition(bestTarget, 'enraged') &&
      !BattleCalc.getCondition(bestTarget, 'unshakeable')
    ) {
      return this.branches[this.NOT_ENRAGED].query(bestTarget);
    } else {
      return this.branches[this.MESSED_UP].query();
    }
  };

  return node;
};
module.exports = Q_status_of_best_target;
